<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M4.5 1.5H3.5L3.12411 3.37946C3.04832 3.7584 2.76097 4.05976 2.38606 4.15348L1 4.5V5.5L2.38606 5.84652C2.76097 5.94024 3.04832 6.2416 3.12411 6.62054L3.5 8.5H4.5L4.87589 6.62054C4.95168 6.2416 5.23903 5.94024 5.61394 5.84652L7 5.5V4.5L5.61394 4.15348C5.23903 4.05976 4.95168 3.7584 4.87589 3.37946L4.5 1.5Z"
    fill="currentColor"
  />
  <path
    d="M13.2411 10.6359C12.7376 11.9944 12.6431 13.4743 12.9736 14.8898L12.9999 15.0002H10.9999L9.99994 12.5002V15.0002H6.99994L7.99994 12.5002L5.49994 15.0002H1.99994L5.88275 12.0793C7.0529 11.1988 7.97927 10.0369 8.58002 8.70523L13.2411 10.6359ZM13.5576 1.43277C13.7161 1.05009 14.1553 0.868007 14.538 1.02652C14.9205 1.18511 15.1017 1.62345 14.9433 2.00601L13.039 6.60562C13.0674 6.61926 13.0954 6.63205 13.122 6.64566C13.3122 6.7433 13.5128 6.87005 13.6806 7.06656C13.9204 7.34751 14.0657 7.69732 14.0947 8.06558C14.1148 8.32307 14.0624 8.55452 13.997 8.75797C13.9498 8.90476 13.8836 9.06949 13.8105 9.24722L9.15912 7.32144C9.23323 7.14373 9.30347 6.98035 9.37396 6.84293C9.47157 6.65276 9.59845 6.45216 9.79486 6.28433C10.0757 6.0445 10.4257 5.89933 10.7939 5.87027C11.0512 5.85007 11.2819 5.90257 11.4853 5.96793C11.5392 5.98527 11.5957 6.00776 11.6542 6.02945L13.5576 1.43277Z"
    fill="currentColor"
  />
</svg>
